export default __webpack_public_path__ + "static/logo-cdb5111eadde375c20030277ae2b2d40.png";